import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, ChevronRight, Loader2 } from 'lucide-react';
import { API_URL } from '../config';

const CongesSoldeBanner = ({ authToken, authUser, onNavigate }) => {
  const [solde, setSolde] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingCount, setPendingCount] = useState(0);

  const isAdmin = ['Patron', 'Super Manager'].includes(authUser.role_name);

  const loadSolde = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/conges-solde/${authUser.id}`, {
        headers: { 'Authorization': `Bearer ${authToken}` }
      });
      if (res.ok) setSolde(await res.json());
    } catch (err) {
      console.error('Erreur chargement solde bannière:', err);
    } finally {
      setLoading(false);
    }
  }, [authToken, authUser.id]);

  const loadPendingCount = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const res = await fetch(`${API_URL}/conges?statut=en_attente`, {
        headers: { 'Authorization': `Bearer ${authToken}` }
      });
      if (res.ok) {
        const data = await res.json();
        setPendingCount(Array.isArray(data) ? data.length : 0);
      }
    } catch (err) {
      // silencieux
    }
  }, [authToken, isAdmin]);

  useEffect(() => { loadSolde(); loadPendingCount(); }, [loadSolde, loadPendingCount]);

  if (loading) {
    return (
      <div className="bg-teal-50 dark:bg-teal-950/40 border border-teal-200 rounded-xl p-3 mb-4 flex items-center gap-2">
        <Loader2 className="w-4 h-4 text-teal-500 animate-spin" />
        <span className="text-sm text-teal-600 dark:text-teal-400">Chargement du solde...</span>
      </div>
    );
  }

  if (!solde) return null;

  const soldeColor = solde.restant < 5 ? 'text-red-700 bg-red-50 dark:bg-red-950/40 border-red-200 dark:border-red-800' :
                     solde.restant < 10 ? 'text-orange-700 bg-orange-50 dark:bg-orange-950/40 border-orange-200 dark:border-orange-800' :
                     'text-teal-700 bg-teal-50 dark:bg-teal-950/40 border-teal-200 dark:border-teal-800';

  return (
    <div className={`border rounded-xl p-3 mb-4 flex items-center justify-between ${soldeColor}`}>
      <div className="flex items-center gap-3">
        <Calendar className="w-5 h-5 opacity-70" />
        <div className="text-sm">
          <span className="font-semibold">Mon solde CP : {solde.restant} jours restants</span>
          <span className="opacity-70 ml-2">
            (Acquis: {solde.total_acquis} · Pris: {solde.pris}
            {solde.en_attente > 0 && ` · En attente: ${solde.en_attente}`})
          </span>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {isAdmin && pendingCount > 0 && (
          <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-full">
            {pendingCount} en attente
          </span>
        )}
        <button
          onClick={() => onNavigate && onNavigate('solde_cp')}
          className="flex items-center gap-1 text-xs font-medium opacity-80 hover:opacity-100 transition"
        >
          Voir détail <ChevronRight className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};

export default CongesSoldeBanner;
